module.exports = __webpack_public_path__ + "static/media/BANANA-GUARD-BNB.4b920329.svg";